<form [formGroup]="twoStepVerifyForm">
  <div id='2FA' class="fdx-o-grid__item--11">

    <!-- Two-step verification section -->
    <h4 class="fdx-u-font-size--h4 fdx-u-text--light fdx-u-mb--4 fdx-u-mt--5" id="verification-title">
      {{ 'twoStepVerification.title' | translate}}
    </h4>
    <p class="fdx-u-font-size--h7 fdx-u-text--light fdx-u-mb--4" id="twoStepVerification-message">
      {{ 'twoStepVerification.message' | translate}}
    </p>
  </div>
  @if (isAPIFailLoginScreen && !sharedService.isPerformanceExecutorOn()) {
    <div class="fdx-o-grid__item--12">
      <wpro-login-call-failure></wpro-login-call-failure>
    </div>
  }
  <div class="fdx-o-grid__item--11">
    @if (!isAPIFailLoginScreen || sharedService.isPerformanceExecutorOn()) {
      <div class="fdx-o-grid__item--12">
        <div class="fdx-o-grid">
          <div class="fdx-o-grid__row fdx-u-mb--4">
            <div class="fdx-o-grid__item fdx-o-grid__item--12@small-only fdx-u-pr--12@large">
              <h2 class="fdx-c-heading  fdx-c-heading--h5 fdx-c-heading--bold" id="text-1">
              {{ 'twoStepVerification.twoStepVerificationAtLogin' | translate}}</h2>
              <p class="fdx-c-paragraph fdx-c-paragraph--regular fdx-u-mt--1" id="text-2">
              {{ 'twoStepVerification.enableMessage' | translate}}</p>
            </div>
            <!-- Two-step verification at login toggle section -->
            <div class="fdx-o-grid__item--auto fdx-u-display--flex fdx-u-flex-align-items--center fdx-u-pl--5@large">
              <div class="fdx-c-form-group fdx-c-form-group--toggle fdx-u-mb--3@small-only">
                @if (isTwoSVToggleLoading) {
                  <wpro-spinner-small></wpro-spinner-small>
                }
                @if (!isTwoSVToggleLoading) {
                  <input (click)="toggleMfaCheck($event)" formControlName="mfaOnLogin" type="checkbox" name="format"
                    id="check5.1" aria-describedby="text-1 text-2" class="fdx-c-form-group__checkbox" required="">
                }
                @if (twoStepVerifyForm.controls['mfaOnLogin'].value) {
                  <label class="fdx-c-form-group__label"
                  for="check5.1" id="check4">{{ 'twoStepVerification.toggleOn' | translate}}</label>
                }
                @if (!twoStepVerifyForm.controls['mfaOnLogin'].value) {
                  <label class="fdx-c-form-group__label"
                  for="check5.1" id="check4">{{ 'twoStepVerification.toggleOff' | translate}}</label>
                }
              </div>
            </div>
          </div>
          <!-- Location restriction toggle section -->
          @if (!locRestriction) {
            <div class="fdx-o-grid__row">
              <div class="fdx-o-grid__item fdx-o-grid__item--12@small-only fdx-u-pr--12@large">
                <h2 class="fdx-c-heading  fdx-c-heading--h5 fdx-c-heading--bold" id="text-3">
                {{ 'twoStepVerification.locationRestriction' | translate }}</h2>
                <p class="fdx-c-paragraph fdx-c-paragraph--regular fdx-u-mt--1" id="text-4">
                {{ 'twoStepVerification.locationRestrictionMessage' | translate }}</p>
              </div>
              <div class="fdx-o-grid__item--auto fdx-u-display--flex fdx-u-flex-align-items--center fdx-u-pl--5@large">
                <div class="fdx-c-form-group fdx-c-form-group--toggle fdx-u-mb--3@small-only ">
                  <input (click)="changeLocationRestriction($event)" formControlName="restrictOutsideCountryLogin"
                    type="checkbox" name="format" id="check5.2" aria-describedby="text-3 text-4"
                    class="fdx-c-form-group__checkbox" required="">
                  @if (twoStepVerifyForm.controls['restrictOutsideCountryLogin'].value) {
                    <label
                      class="fdx-c-form-group__label" for="check5.2" id="check6">{{ 'twoStepVerification.toggleOn' |
                    translate}}</label>
                  }
                  @if (!twoStepVerifyForm.controls['restrictOutsideCountryLogin'].value) {
                    <label
                      class="fdx-c-form-group__label" for="check5.2" id="check7">{{ 'twoStepVerification.toggleOff' |
                    translate}}</label>
                  }
                </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <!-- Default verification method section -->
      @if (isTwoFAEnabled) {
        <div>
          <h2 class="fdx-u-font-size--h5 fdx-u-text--light fdx-u-mb--4 fdx-u-mr--2" id="defaultMethodTitle">
            {{ 'twoStepVerification.defaultVerificationMethodTitle' | translate}}
          </h2>
          <p class="fdx-u-font-size--default fdx-u-text--light fdx-u-align--left fdx-u-mt--0 fdx-u-mb--6" aria-atomic="true"
            aria-live="assertive">
            <span aria-atomic="true" id='contactInfoClick_id' aria-live="assertive" (click)="contactInfoClick($event)"
              (keydown.enter)="contactInfoClick($event)" [innerHTML]="'twoStepVerification.verificationMethodMessage' | translate">
            </span>
          </p>
        </div>
      }
    </div>
    @if (isAPIFailLoginScreen && !sharedService.isPerformanceExecutorOn()) {
      <div class="fdx-o-grid__item--12">
        <wpro-login-call-failure></wpro-login-call-failure>
      </div>
    }
    @if (isTwoFAEnabled) {
      <div>
        @if (!isAPIFailLoginScreen || sharedService.isPerformanceExecutorOn()) {
          <div>
            <!-- EMAIL section -->
            @for (contact of contactDetails; track contact) {
              <div class="fdx-o-grid__item--12">
                @if (contact.deliveryMethod === 'EMAIL') {
                  <div class="fdx-c-form-group fdx-c-form-group--radio ">
                    <input formControlName="deliveryChannelPreference" type="radio" (change)="changeMFAPrefrenceType('EMAIL')"
                      name="deliveryChannelPreference" id="email" value="EMAIL" aria-describedby="me-1"
                      class="fdx-c-form-group__radio" aria-labelledby="email">
                      <label class="fdx-c-form-group__label fdx-u-text--bold" for="email" id="email-label">{{
                      'twoStepVerification.email' | translate}}</label>
                      @if (isDecoupleTwoFAEdit) {
                        <div
                          class="fdx-c-form-group__message fdx-c-form-group__message--has-message fdx-u-text--bold fdx-u-mb--3"
                        id="me-1">{{contact.value}}</div>
                      }
                      @if (!isDecoupleTwoFAEdit) {
                        <div
                          class="fdx-c-form-group__message fdx-c-form-group__message--has-message fdx-u-text--bold fdx-u-mb--3"
                        id="me-1">{{personalEmail.value}}</div>
                      }
                    </div>
                  }
                  <!-- SMS Section -->
                  @if (contact.deliveryMethod === 'SMS') {
                    <div>
                      <div class="fdx-c-form-group fdx-c-form-group--radio">
                        <input formControlName="deliveryChannelPreference" type="radio" (change)="changeMFAPrefrenceType('SMS')"
                          name="deliveryChannelPreference" id="text" value="SMS" aria-describedby="me-2"
                          class="fdx-c-form-group__radio" aria-labelledby="text">
                          <label class="fdx-c-form-group__label fdx-u-text--bold" for="text" id="text-label">{{
                          'twoStepVerification.textMessage' | translate}}</label>
                          <p class="fdx-c-form-group__message fdx-c-form-group__message--has-message fdx-u-mt--0 fdx-u-mb--0 fdx-o-grid__item--10@large"
                            aria-atomic="true" aria-live="assertive">
                            <span aria-atomic="true" id='termsAndConditions_id' aria-live="assertive"
                              (click)="termsAndConditionClick($event)" (keydown.enter)="termsAndConditionClick($event)"
                              [innerHTML]="'twoStepVerification.termsAndConditions' | translate">
                            </span>
                          </p>
                          <!--[READ-ONLY] Selected/Available Phone number-->
                          @if (twoStepVerifyForm.controls.deliveryChannelPreference.value !== 'SMS' || isDecoupleSecondaryPhone) {
                            <div
                              class="fdx-c-form-group__message fdx-c-form-group__message--has-message fdx-u-text--bold fdx-u-mb--3"
                              id="me-2">
                              {{textMsgNumberSelected}}
                            </div>
                          }
                        </div>
                        @if (!secondaryPhoneNumber && !twoFactorEditDecoupleFlag &&
                          twoStepVerifyForm.controls.deliveryChannelPreference.value === 'SMS' && !isDecoupleSecondaryPhone) {
                          <div id="me-2">
                            <!-- B-834663-Secondary phone number alternatively added through new field under Default Verification Methods -->
                            <wpro-add-new-number
                              [deliveryType]="deliveryType"
                              (successfulSaveFlag)="fetchUserDetails($event)">
                            </wpro-add-new-number>
                          </div>
                        }
                        @if (secondaryPhoneNumber &&
                          twoStepVerifyForm.controls.deliveryChannelPreference.value === 'SMS' && !isDecoupleSecondaryPhone) {
                          <wpro-form-select
                            [config]="textDropdownConfig"
                            [isLoading]="isPhoneNumLoading"
                            [dropdownControl]="textMsgDropdownControl"
                            (selectedValue)="changeMFAPreferencePhoneType($event, 'SMS')">
                            <option value="null" class="form-option__element" disabled>Please select</option>
                            <option [selected]="textMsgNumberSelected.includes(primaryPhoneNumber)"
                              value="{{'PHONE'}}" class="form-option__element">
                              +{{countryCode}} {{primaryPhoneNumber}}
                            </option>
                            <option [selected]="textMsgNumberSelected.includes(secondaryPhoneNumber)"
                              value="{{'MOBILE'}}" class="form-option__element">
                              +{{countryCode}} {{secondaryPhoneNumber}}
                            </option>
                            <span class="label-phone-number">
                              {{ textMsgSelectedLabel | translate }}
                            </span>
                          </wpro-form-select>
                        }
                      </div>
                    }
                    <!-- CALL section -->
                    @if (contact.deliveryMethod === 'CALL') {
                      <div>
                        <div class="fdx-c-form-group fdx-c-form-group--radio ">
                          <input formControlName="deliveryChannelPreference" type="radio" (change)="changeMFAPrefrenceType('CALL')"
                            name="deliveryChannelPreference" id="call" value="CALL" aria-describedby="me-3"
                            class="fdx-c-form-group__radio" aria-labelledby="call">
                            <label class="fdx-c-form-group__label fdx-u-text--bold" for="call" id="call-label">
                              {{'twoStepVerification.phoneCall' | translate}}
                            </label>
                            <!--[READ-ONLY] Selected/Available Phone number-->
                            @if (twoStepVerifyForm.controls.deliveryChannelPreference.value !== 'CALL' || isDecoupleSecondaryPhone) {
                              <div
                                class="fdx-c-form-group__message fdx-c-form-group__message--has-message fdx-u-text--bold fdx-u-mb--3"
                                id="me-3">
                                {{phoneCallNumberSelected}}
                              </div>
                            }
                          </div>
                          @if (!secondaryPhoneNumber &&
                            twoStepVerifyForm.controls.deliveryChannelPreference.value === 'CALL' && !isDecoupleSecondaryPhone && !twoFactorEditDecoupleFlag) {
                            <div id="me-3">
                              <!-- B-834663-Secondary phone number alternatively added through new field under Default Verification Methods -->
                              <wpro-add-new-number
                                [deliveryType]="deliveryType"
                                (successfulSaveFlag)="fetchUserDetails($event)">
                              </wpro-add-new-number>
                            </div>
                          }
                          @if (secondaryPhoneNumber &&
                            twoStepVerifyForm.controls.deliveryChannelPreference.value === 'CALL' && !isDecoupleSecondaryPhone) {
                            <wpro-form-select
                              [config]="phoneDropdownConfig"
                              [isLoading]="isPhoneNumLoading"
                              [dropdownControl]="phoneCallDropdownControl"
                              (selectedValue)="changeMFAPreferencePhoneType($event, 'CALL')">
                              <option value="null" class="form-option__element" disabled>Please select</option>
                              <option [selected]="phoneCallNumberSelected.includes(primaryPhoneNumber)"
                                value="{{'PHONE'}}" class="form-option__element">
                                +{{countryCode}} {{primaryPhoneNumber}}
                              </option>
                              <option [selected]="phoneCallNumberSelected.includes(secondaryPhoneNumber)"
                                value="{{'MOBILE'}}" class="form-option__element">
                                +{{countryCode}} {{secondaryPhoneNumber}}
                              </option>
                              <span class="label-phone-number">
                                {{ phoneCallSelectedLabel | translate }}
                              </span>
                            </wpro-form-select>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }

          <!--B676133, continue popup-->
          @if (showPopUp) {
            <wpro-continue-confirmation (hidePopup)="hidePopup($event)" (continue)="continue()">
            </wpro-continue-confirmation>
          }
        </form>

        <ng-template #twoFactorElevationFailure>
          <p>{{'contact.twoFactorElevationError' | translate}}</p>
        </ng-template>
